<template>
  <div class="content background2">
    <div class="searchBox2">
      <div class="searchBox-list">
        <div class="searchBox-black">
          <label class="searchBox-label">客户名称</label>
          <div class="searchBox-condition">
            <el-input
              class="input-class"
              v-model="searchParam.customerName"
              placeholder="请输入客户名称"
            >
            </el-input>
          </div>
        </div>
        <div class="searchBox-black">
          <label class="searchBox-label">签订日期</label>
          <div class="searchBox-condition">
            <el-date-picker
              class="date-class"
              v-model="searchParam.signTime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="searchBox-black">
          <label class="searchBox-label">至</label>
          <div class="searchBox-condition">
            <el-date-picker
              class="date-class"
              v-model="searchParam.signTime2"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="searchBox-black">
          <label class="searchBox-label">客户类型</label>
          <div class="searchBox-condition" style="width: 150px">
            <el-select
              class="select-class"
              v-model="searchParam.customerType"
              placeholder="请选择"
            >
              <el-option :label="'全部'" :value="''"></el-option>
              <el-option
                v-for="(item, index) in customerTypeList"
                :label="item.name"
                :value="item.id"
                :key="index"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchBox-black">
          <label class="searchBox-label">负责人员</label>
          <div class="searchBox-condition" style="width: 150px">
            <el-select
              class="select-class"
              v-model="searchParam.personChargeName"
              :clearable="true"
              :filterable="true"
              placeholder="请选择负责人员"
            >
              <el-option :label="'全部'" :value="''"></el-option>
              <template v-for="(item, index) in personChargeNameList">
                <el-option
                  :label="item.fullName"
                  :value="item.fullName"
                  :key="index"
                >
                </el-option>
              </template>
            </el-select>
          </div>
        </div>
        <!-- <div class="searchBox-black">
          <label class="searchBox-label">维保模式</label>
          <div class="searchBox-condition" style="width: 150px">
            <el-select
              class="select-class"
              v-model="searchParam.maintenanceType"
              placeholder="请选择"
            >
              <el-option :label="'全部'" :value="''"></el-option>
              <el-option
                v-for="(item, index) in maintenanceList"
                :label="item.name"
                :value="item.id"
                :key="index"
              >
              </el-option>
            </el-select>
          </div>
        </div> -->
        <div
          class="searchButton"
          @click="search({ pageNo: 1, pageSize: pageSize })"
        >
          查询
        </div>
      </div>
      <div class="searchBox-button">
        <label class="searchBox-label">合同状态</label>
        <div class="searchBox-condition">
          <ul class="searchBox-condition-list">
            <li
              :class="{ on: searchParam.status === item.id }"
              v-for="(item, index) in stateList"
              @click="searchStatus(item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="tableList2" style="height: 220px">
      <div style="position: relative; width: 100%; background-color: #fff">
        <div class="tableTitle">
          <p class="title">详细内容</p>
          <excel-export
            :filename="utils.getNowFormatDate() + '合同列表'"
            :sheet="sheet"
            class="exportButtonWrapper"
          >
            <div 
              class="exportButton" @click="getExcelList()"
              v-if="this.menuList.indexOf('CD_410') != -1"
            >
              导出
            </div>
          </excel-export>
          <div
            class="signedButton"
            @click="sign"
            v-if="this.menuList.indexOf('CD_430') != -1"
          >
            签订
          </div>
          <div
            class="RenewButton"
            @click="renewal"
            v-if="this.menuList.indexOf('CD_420') != -1"
          >
            续签
          </div>
          <div class="detailButton" @click="detail">查看详情</div>
          <div
            class="InvalidButton"
            @click="Invalid"
            v-if="this.menuList.indexOf('CD_440') != -1"
          >
            作废
          </div>
        </div>
      </div>
    </div>
    <div ref="tableList" class="list" style="z-index: 10; padding-top: 220px">
      <List
        :tableData="tableData"
        :tableList="tableList"
        :pageSize="pageSize"
        :pageNo="pageNo"
        @parentMethod="getInfo"
      ></List>
    </div>
    <div ref="page" class="page">
      <Page
        ref="pageModel"
        :total="pageCount"
        :display="pageSize"
        :pagegroup="3"
        :currentspage="1"
        @parentMethod="search"
      ></Page>
    </div>
    <el-dialog
      title="签订"
      :center="true"
      :visible.sync="signDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="500px"
      custom-class="dialog-style dialogLoading"
    >
      <div class="dialog-content">
        <el-form ref="form" :model="signParam" label-width="120px">
          <el-form-item label="客户名称">
            <el-autocomplete
              style="width: 100%"
              v-model="signParam.customerName"
              :fetch-suggestions="queryCustomer"
              @select="selectCustomer"
              :trigger-on-focus="false"
              value-key="customerName"
            >
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="所在区域地址">
            <el-input v-model="signParam.address" disabled=""></el-input>
          </el-form-item>
          <el-form-item label="签订日期">
            <el-date-picker
              v-model="signParam.signTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间"
              :clearable="false"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="开始日期">
            <el-date-picker
              v-model="signParam.startDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间"
              :clearable="false"
              :picker-options="pickerOptions0"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="到期日期">
            <el-date-picker
              v-model="signParam.endDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间"
              :clearable="false"
              :picker-options="pickerOptions1"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="签订人员">
            <el-autocomplete
              style="width: 100%"
              v-model="signParam.signStaffName"
              placeholder="请选择签订人员"
              :fetch-suggestions="queryStaff1"
              @select="selectStaff1"
              :trigger-on-focus="true"
              value-key="fullName"
            >
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="负责人员">
            <el-autocomplete
              style="width: 100%"
              v-model="signParam.personChargeName"
              placeholder="请选择负责人员"
              :fetch-suggestions="queryStaff2"
              @select="selectStaff2"
              :trigger-on-focus="true"
              value-key="fullName"
            >
            </el-autocomplete>
          </el-form-item>
          <!-- 维保内容 -->
          <el-form-item
            v-for="(item, index) in maintenanceDictContents"
            :label="item.name"
            :key="index"
            v-if="signDialog"
          >
            <el-select
              v-model="signParam.maintenanceTypes[index].maintenanceCycleId"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(item1, index1) in maintenanceList"
                :label="item1.name"
                :value="item1.id"
                :key="index1"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="合同文件">
            <el-upload
              class="upload-demo"
              action="/"
              :show-file-list="false"
              :http-request="upload"
              :before-upload="beforeAvatarUpload"
            >
              <el-button :loading="loading">{{ uploadFileText }}</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="signDialog = false" :loading="loading"
          >取 消</el-button
        >
        <el-button type="primary" @click="signSave()" :loading="loading"
          >签 订</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="查看详情"
      :center="true"
      :visible.sync="detailDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="500px"
      custom-class="dialog-style dialogLoading"
    >
      <div class="dialog-content">
        <el-form ref="form" :model="detailParam" label-width="120px">
          <el-form-item label="客户名称">
            <el-autocomplete
              style="width: 100%"
              v-model="detailParam.customerName"
              :fetch-suggestions="queryCustomer"
              @select="selectCustomer"
              :trigger-on-focus="false"
              disabled
              value-key="customerName"
            >
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="所在区域地址">
            <el-input
              v-model="detailParam.address"
              disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item label="签订日期">
            <el-date-picker
              v-model="detailParam.signTime"
              type="date"
              value-format="yyyy-MM-dd"
              disabled
              placeholder="选择日期时间"
              :clearable="false"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="开始日期">
            <el-date-picker
              v-model="detailParam.startDate"
              type="date"
              disabled
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间"
              :clearable="false"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="到期日期">
            <el-date-picker
              v-model="detailParam.endDate"
              type="date"
              value-format="yyyy-MM-dd"
              disabled
              placeholder="选择日期时间"
              :clearable="false"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="签订人员">
            <el-autocomplete
              style="width: 100%"
              v-model="detailParam.signStaffName"
              placeholder="请选择签订人员"
              :fetch-suggestions="queryStaff1"
              @select="selectStaff1"
              disabled
              :trigger-on-focus="true"
              value-key="fullName"
            >
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="负责人员">
            <el-autocomplete
              style="width: 100%"
              v-model="detailParam.personChargeName"
              placeholder="请选择负责人员"
              :fetch-suggestions="queryStaff2"
              @select="selectStaff2"
              :trigger-on-focus="true"
              disabled
              value-key="fullName"
            >
            </el-autocomplete>
          </el-form-item>
          <!-- 维保内容 -->
          <el-form-item
            v-for="(item, index) in maintenanceDictContents"
            :label="item.name"
            :key="index"
            v-if="detailDialog"
          >
            <el-input
              disabled
              v-for="(item2, index2) in maintenanceTypeValue"
              :value="maintenanceTypeValue[index2].name"
              :key="index2"
              v-if="maintenanceTypeValue[index2].id == item.maintenanceTypeId"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="合同文件">
            <el-button @click="downloadFile(detailParam.contractUrl)"
              >下载</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      title="续签"
      :center="true"
      :visible.sync="renewalDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="500px"
      custom-class="dialog-style dialogLoading"
    >
      <div class="dialog-content">
        <el-form ref="form" :model="renewalParam" label-width="120px">
          <el-form-item label="客户名称">
            <el-input
              v-model="renewalParam.customerName"
              disabled=""
            ></el-input>
          </el-form-item>
          <el-form-item label="所在区域地址">
            <el-input v-model="renewalParam.address" disabled=""></el-input>
          </el-form-item>
          <el-form-item label="签订日期">
            <el-date-picker
              v-model="renewalParam.signTime"
              type="date"
              disabled=""
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="开始日期">
            <el-date-picker
              v-model="renewalParam.startDate"
              type="date"
              disabled=""
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间"
              :picker-options="pickerOptions2"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="到期日期">
            <el-date-picker
              v-model="renewalParam.endDate"
              type="date"
              :clearable="false"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions3"
              placeholder="选择日期时间"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="签订人员">
            <el-autocomplete
              style="width: 100%"
              v-model="renewalParam.signStaffName"
              :fetch-suggestions="queryStaff1"
              @select="selectStaff3"
              :trigger-on-focus="false"
              value-key="fullName"
            >
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="负责人员">
            <el-autocomplete
              style="width: 100%"
              v-model="renewalParam.personChargeName"
              :fetch-suggestions="queryStaff2"
              @select="selectStaff4"
              :trigger-on-focus="false"
              value-key="fullName"
            >
            </el-autocomplete>
          </el-form-item>
          <!-- 维保内容 -->
          <el-form-item
            v-for="(item, index) in maintenanceDictContents"
            :label="item.name"
            :key="index"
            v-if="renewalDialog"
          >
            <el-select
              v-model="renewalParam.maintenanceTypes[index].maintenanceCycleId"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(item1, index1) in maintenanceList"
                :label="item1.name"
                :value="item1.id"
                :key="index1"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="维保模式">
            <el-select
              v-model="renewalParam.maintenanceType"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in maintenanceList"
                :label="item.name"
                :value="item.id"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="合同文件">
            <el-upload
              class="upload-demo"
              action="/"
              :show-file-list="false"
              :http-request="upload"
              :before-upload="beforeAvatarUpload"
            >
              <el-button :loading="loading">{{ uploadFileText }}</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="renewalDialog = false" :loading="loading"
          >取 消</el-button
        >
        <el-button type="primary" @click="renewalSave()" :loading="loading"
          >续 签</el-button
        >
      </span>
      <!--
        所属区域是详细地址，这个做的时候要注意
        续签时  签订日期  是 上一次的 到期日期
        续签时  到期日期  默认 一年
        续签时  签订人员 默认 签订时的人员，可以修改
        续签时  负责人员 默认 签订时的人员，可以修改
        续签时  维保模式 默认 签订时的，可以修改
       -->
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/css/common/list.css";
import SearchList from "@/components/list/searchList";
import BtnList from "@/components/list/btnList";
import List from "@/components/list/list";
import Page from "@/components/common/page";
import Contract from "@/assets/js/contract/contract.js";
import CommonJs from "@/assets/js/common/common.js";
var id = 0;
export default {
  name: "alarm",
  components: {
    Page,
    List,
  },
  data() {
    return {
      searchParam: {
        customerName: "",
        signTime: "",
        signTime2: "",
        personChargeName: "",
        maintenanceType: "",
        customerType: "",
        status: "",
      },
      options: [],
      maintenanceTypeValue: [],
      checkList: [],
      signDialog: false,
      detailDialog: false,
      signParam: {
        startDate: "",
        customerId: "",
        customerName: "",
        address: "",
        signTime: "",
        endDate: "",
        signStaff: "",
        personChargeName: "",
        personCharge: "",
        maintenanceTypes: "",
        signStaffName: "",
        areaCode: "",
      },
      detailParam: {
        startDate: "",
        customerId: "",
        customerName: "",
        address: "",
        signTime: "",
        endDate: "",
        signStaff: "",
        personChargeName: "",
        personCharge: "",
        maintenanceType: "",
        signStaffName: "",
        areaCode: "",
      },
      renewalDialog: false,
      renewalParam: {
        startDate: "",
        customerId: "",
        customerName: "",
        address: "",
        signTime: "",
        endDate: "",
        signStaff: "",
        personChargeName: "",
        personCharge: "",
        maintenanceTypes: "",
        signStaffName: "",
        areaCode: "",
      },
      stateList: [],
      customerTypeList: [],
      maintenanceList: [],
      maintenanceDictContents: [],
      personChargeNameList: [],
      tableList: [
        {
          column: "customerName",
          title: "客户名称",
          headerAlign: "center",
          align: "center",
          width: "20%",
        },
        {
          column: "address",
          title: "所在区域地址",
          headerAlign: "center",
          align: "center",
          width: "20%",
        },
        {
          column: "signTime",
          title: "签订日期",
          headerAlign: "center",
          align: "center",
          width: "20%",
        },
        {
          column: "startDate",
          title: "开始日期",
          headerAlign: "center",
          align: "center",
          width: "20%",
        },
        {
          column: "endDate",
          title: "到期日期",
          headerAlign: "center",
          align: "center",
          width: "20%",
        },
        {
          column: "signStaffName",
          title: "签订人员",
          headerAlign: "center",
          align: "center",
          width: "20%",
        },
        {
          column: "personChargeName",
          title: "负责人员",
          headerAlign: "center",
          align: "center",
          width: "20%",
        },
        {
          column: "status",
          title: "合同状态",
          headerAlign: "center",
          align: "center",
          termList: [],
          width: "20%",
        },
      ],
      tableData: [],
      sheet: [
        {
          title: "合同表",
          tHeader: [
            "客户名称",
            "所在区域地址",
            "签订日期",
            "开始日期",
            "到期日期",
            "签订人员",
            "负责人员",
            // "维保模式",
            "合同状态",
          ],
          keys: [
            "customerName",
            "address",
            "signTime",
            "startDate",
            "endDate",
            "signStaffName",
            "personChargeName",
            // "maintenanceTypeName",
            "statusName",
          ],
          table: [],
          sheetName: "合同",
          cellStyle: [
            {
              cell: "A1",
              font: {
                name: "黑体",
                sz: "18px",
              },
            },
          ],
        },
      ],
      tableInfo: {},
      pageCount: 20,
      pageSize: 10,
      pageNo: 1,
      menuList: [],
      filePath: "",
      uploadFileText: "上传文件",
      loading: false,
    };
  },
  computed: {
    pickerOptions0() {
      return {
        disabledDate: (time) => {
          if (this.signParam.endDate) {
            return time.getTime() > new Date(this.signParam.endDate).getTime();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      };
    },
    pickerOptions1() {
      return {
        disabledDate: (time) => {
          if (this.signParam.startDate) {
            return (
              time.getTime() <
              new Date(this.signParam.startDate).getTime() +
                30 * 24 * 60 * 60 * 1000
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      };
    },
    pickerOptions2() {
      return {
        disabledDate: (time) => {
          if (this.renewalParam.endDate) {
            return (
              time.getTime() > new Date(this.renewalParam.endDate).getTime()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      };
    },
    pickerOptions3() {
      return {
        disabledDate: (time) => {
          if (this.renewalParam.startDate) {
            return (
              time.getTime() <
              new Date(this.renewalParam.startDate).getTime() +
                30 * 24 * 60 * 60 * 1000
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      };
    },
  },
  methods: {

    upload(res, file) {
      let formdata = new FormData();
      formdata.append("file", res.file);
      this.loading = true;
      Contract.uploadFile(formdata)
        .then((response) => {
          let data = response.data;
          if (data.code == 1) {
            this.loading = false;
            this.filePath = data.data;
            let fileName = data.data.split("\\")[2].split(".")[0];
            this.uploadFileText = "上传成功  " + fileName;
          } else {
            this.loading = false;
            this.uploadFileText = "上传文件";
            this.utils.tipsAlert("上传失败。");
          }
        })
        .catch((response) => {
          this.loading = false;
          this.utils.tipsAlert("上传失败。");
        });
    },
    downloadFile(url) {
	  console.log(url);
      if (url == null || url == "") {
        this.utils.tipsAlert("暂无上传文件");
        return;
      }
      window.location.href = this.$store.getters.getPostUrl + "/contract/download/file?fileName=" + encodeURI(url);
    },
    beforeAvatarUpload() {},
    queryArea(item) {
      let param = {
        pageNo: 1,
        pageSize: this.pageSize,
      };
      if (item == "all") {
        this.$delete(this.searchParam, "city");
        this.$delete(this.searchParam, "district");
        param = Object.assign(param, item);
        this.search(param);
      } else {
        this.$delete(this.searchParam, "city");
        this.$delete(this.searchParam, "district");
        param = Object.assign(param, item);
        this.searchParam = Object.assign(this.searchParam, item);
        this.search(param);
      }
    },
    getContractStatusList() {
      CommonJs.getDict("合同状态")
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            let list = [];
            data.data.forEach(function (item, index) {
              var param = {};
              param.id = item.rank;
              param.name = item.value;
              param.color = item.value1;
              list.push(param);
            });
            this.stateList = list;
            this.tableList[7].termList = list;
          }
        })
        .catch((response) => {});
    },
    Invalid() {
      if (Object.keys(this.tableInfo).length > 0) {
        this.$confirm("此操作将作废合同, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let list = {
              id: this.tableInfo.id,
              status: 4,
            };
            Contract.edit(list).then((response) => {
              const data = response.data;
              if (data.code == 1) {
                this.utils.tipsAlert("作废" + data.message);
                this.search({
                  pageNo: this.pageNo,
                  pageSize: this.pageSize,
                });
              }
            });
          })
          .catch(() => {});
      } else {
        this.utils.tipsAlert("请选择数据");
      }
    },
    detail() {
      if (Object.keys(this.tableInfo).length > 0) {
        this.detailParam = this.tableInfo;
        this.maintenanceTypeValue = [];
        for (var i = 0; i < this.maintenanceList.length; i++) {
          for (var q = 0; q < this.detailParam.maintenanceType.length; q++) {
            if (
              this.maintenanceList[i].id ==
              this.detailParam.maintenanceType[q].maintenanceCycleId
            ) {
              this.maintenanceTypeValue.push({
                id: this.detailParam.maintenanceType[q].maintenanceTypeId,
                name: this.maintenanceList[i].name,
              });
            }
          }
        }
        this.detailDialog = true;
      } else {
        this.utils.tipsAlert("请选择数据");
      }
    },
    getMaintenanceList() {
      CommonJs.getDict("维保类型")
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            let list = [];
            data.data.forEach(function (item, index) {
              var param = {};
              param.id = item.id;
              param.name = item.value;
              list.push(param);
            });
            this.maintenanceList = list;
          }
        })
        .catch((response) => {});
    },
    getCustomerTypeList() {
      CommonJs.getDict("客户类型")
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            let list = [];
            data.data.forEach(function (item, index) {
              var param = {};
              param.id = item.rank;
              param.name = item.value;
              list.push(param);
            });
            this.customerTypeList = list;
          }
        })
        .catch((response) => {});
    },
    getPersonChargeNameList() {
      CommonJs.getAllUserInfo()
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            this.personChargeNameList = data.data;
          }
        })
        .catch((response) => {});
    },
    queryCustomer(queryString, cb) {
      Contract.getByName(queryString)
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            cb(data.data);
          }
        })
        .catch((response) => {});
    },
    selectCustomer(item) {
      this.signParam.customerId = item.id;
      this.signParam.customerName = item.customerName;
      this.signParam.address = item.address;
      this.signParam.areaCode = item.areaCode;
    },
    queryStaff1(queryString, cb) {
      if (queryString == undefined) {
        queryString = "";
      }
      CommonJs.getAllUserInfo(queryString)
        .then((response) => {
          let data = response.data;
          if (data.code == 1) {
            cb(data.data);
          }
        })
        .catch((response) => {});
    },
    queryStaff2(queryString, cb) {
      CommonJs.getAllUserInfo(queryString)
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            cb(data.data);
          }
        })
        .catch((response) => {});
    },
    selectStaff1(item) {
      this.signParam.signStaff = item.userId;
      this.signParam.signStaffName = item.fullName;
    },
    selectStaff2(item) {
      this.signParam.personCharge = item.userId;
      this.signParam.personChargeName = item.fullName;
    },
    selectStaff3(item) {
      this.renewalParam.signStaff = item.userId;
      this.renewalParam.signStaffName = item.fullName;
    },
    selectStaff4(item) {
      this.renewalParam.personCharge = item.userId;
      this.renewalParam.personChargeName = item.fullName;
    },
    searchStatus(status) {
      if (this.searchParam.status !== status) {
        this.searchParam.status = status;
      } else {
        this.searchParam.status = "";
      }
    },
    search(param) {
      if (this.searchParam.customerName != "") {
        param.customerName = this.searchParam.customerName;
      }
      if (
        this.searchParam.signTime != "" &&
        this.searchParam.signTime != null &&
        this.searchParam.signTime2 != "" &&
        this.searchParam.signTime2 != null
      ) {
        param.signTime = this.searchParam.signTime;
        param.signTime2 = this.searchParam.signTime2;
      } else {
        if (
          (this.searchParam.signTime != "" &&
            this.searchParam.signTime != null) ||
          (this.searchParam.signTime2 != "" &&
            this.searchParam.signTime2 != null)
        ) {
          this.utils.tipsAlert("请选择签订日期开始与结束日期");
        }
      }
      if (this.searchParam.personChargeName != "") {
        param.personChargeName = this.searchParam.personChargeName;
      }
      if (this.searchParam.customerType !== "") {
        param.customerType = this.searchParam.customerType;
      }
      if (this.searchParam.maintenanceType !== "") {
        param.maintenanceType = this.searchParam.maintenanceType;
      }
      if (
        this.searchParam.district != "" &&
        this.searchParam.district != undefined
      ) {
        param.district = this.searchParam.district;
      }
      if (this.searchParam.status !== "") {
        param.status = this.searchParam.status;
      }
      this.post(param);
      this.getExcelList(param);
    },
    getExcelList(param) {
      Contract.getContractExcel(param)
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            var list = [];
            var $this = this;
            data.data.forEach(function (item, index) {
              var newItem = {};
              newItem.customerName =
                item.customerName == null ? " " : item.customerName;
              newItem.address = item.address == null ? " " : item.address;
              newItem.signTime = item.signTime == null ? " " : item.signTime;
              newItem.startDate = item.startDate == null ? " " : item.startDate;
              newItem.endDate = item.endDate == null ? " " : item.endDate;
              newItem.signStaffName =
                item.signStaffName == null ? " " : item.signStaffName;
              newItem.personChargeName =
                item.personChargeName == null ? " " : item.personChargeName;
              $this.stateList.forEach(function (item1, index1) {
                if (item.status === item1.id) {
                  newItem.statusName = item1.name;
                }
              });
              $this.maintenanceList.forEach(function (item1, index1) {
                if (item.maintenanceType === item1.id) {
                  newItem.maintenanceTypeName = item1.name;
                }
              });
              list.push(newItem);
            });
            this.sheet[0].table = list;
          }
        })
        .catch((response) => {});
    },
    post(param) {
      Contract.getContract(param)
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            this.pageCount = data.data.total;
            this.pageNo = data.data.pages;
            this.$refs["pageModel"].setCurrent(this.pageNo);
            let list = [];
            let nowTime = new Date();
            this.tableData = data.data.records;
          }
        })
        .catch((response) => {});
    },
    signSave() {
      var param = this.signParam;
      if (this.signParam.customerId == "") {
        this.utils.tipsAlert("请选择客户名称");
        return;
      }
      if (this.signParam.signTime == "") {
        this.utils.tipsAlert("请选择签订日期");
        return;
      }
      if (this.signParam.startDate == "") {
        this.utils.tipsAlert("请选择开始日期");
        return;
      }
      if (this.signParam.endDate == "") {
        this.utils.tipsAlert("请选择到期日期");
        return;
      }
      if (this.signParam.signStaff == "") {
        this.utils.tipsAlert("请选择签订人员");
        return;
      }
      if (this.signParam.personChargeName == "") {
        this.utils.tipsAlert("请选择负责人员");
        return;
      }
      for (
        let index = 0;
        index < this.signParam.maintenanceTypes.length;
        index++
      ) {
        if (
          this.signParam.maintenanceTypes[index].maintenanceCycleId == null ||
          this.signParam.maintenanceTypes[index].maintenanceCycleId == ""
        ) {
          this.utils.tipsAlert("请选择维保类型");
          return;
        }
      }

      param.contractUrl = this.filePath;
      Contract.add(param)
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            if (data.data == true) {
              this.utils.tipsAlert("合同创建成功");
              this.search({
                pageNo: this.pageNo,
                pageSize: this.pageSize,
              });
              this.signDialog = false;
            } else {
              this.utils.tipsAlert("企业已签订合同");
            }
          }
        })
        .catch((response) => {});
      this.signParam.clear();
    },
    renewalSave() {
      var param = this.renewalParam;
      param.contractUrl = this.filePath;
      if (this.renewalParam.customerId == "") {
        this.utils.tipsAlert("请选择客户名称");
        return;
      }
      if (this.renewalParam.signTime == "") {
        this.utils.tipsAlert("请选择签订日期");
        return;
      }
      if (this.renewalParam.startDate == "") {
        this.utils.tipsAlert("请选择开始日期");
        return;
      }
      if (this.renewalParam.endDate == "") {
        this.utils.tipsAlert("请选择到期日期");
        return;
      }
      if (this.renewalParam.signStaff == "") {
        this.utils.tipsAlert("请选择签订人员");
        return;
      }
      if (this.renewalParam.personChargeName == "") {
        this.utils.tipsAlert("请选择负责人员");
        return;
      }
      if (this.renewalParam.maintenanceTypes == "") {
        this.utils.tipsAlert("请选择维保类型");
        return;
      }
	  this.renewalParam.status = 1;
	  this.renewalParam.type = 1;
      Contract.add(param)
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            this.utils.saveAlert();
            this.search({
              pageNo: this.pageNo,
              pageSize: this.pageSize,
            });
            this.renewalDialog = false;
          }
        })
        .catch((response) => {});
    },
    getInfo(info) {
      this.tableInfo = info;
    },
    getArea(param) {},
    sign() {
      this.signDialog = true;
      var d = new Date();
      var seperator1 = "-";
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var strDate = d.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      this.getDictList();
      this.signParam = {
        customerId: "",
        signTime: year + seperator1 + month + seperator1 + strDate,
        startDate: year + seperator1 + month + seperator1 + strDate,
        endDate: this.date(year + seperator1 + month + seperator1 + strDate),
        signStaff: this.$store.getters.getUserInfo.userId,
        personChargeName: this.$store.getters.getUserInfo.fullName,
        personCharge: this.$store.getters.getUserInfo.userId,
        maintenanceTypes: this.maintenanceDictContents,
        signStaffName: this.$store.getters.getUserInfo.fullName,
        areaCode: "",
      };
      this.filePath = "";
      this.uploadFileText = "上传文件";
    },
    date(date) {
      var d = new Date(date);
      d.setFullYear(d.getFullYear() + 1);
      var seperator1 = "-";
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var strDate = d.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return year + seperator1 + month + seperator1 + strDate;
    },
    renewal() {
      if (Object.keys(this.tableInfo).length > 0) {
        Contract.getById(this.tableInfo.id).then((response) => {
          const data = response.data;
          if (data.code == 1) {
            this.getDictList();
            this.renewalDialog = true;
            this.renewalParam = {
              contractId: this.tableInfo.id,
              customerId: data.data.id,
              customerName: data.data.customerName,
              areaCode: data.data.areaCode,
              address: data.data.address,
              signTime: data.data.signTime,
              startDate: data.data.endDate,
              endDate: this.date(data.data.endDate),
              signStaff: data.data.signStaff,
              personChargeName: data.data.personChargeName,
              personCharge: data.data.personCharge,
              maintenanceTypes: this.maintenanceDictContents,
              signStaffName: data.data.signStaffName,
            };
            this.filePath = data.data.filePath;
          }
        });
      } else {
        this.utils.tipsAlert("请选择数据");
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getDictList() {
      CommonJs.getDict("维护类型")
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            let list = [];
            data.data.forEach(function (item, index) {
              var param = {};
              param.maintenanceTypeId = item.id;
              param.name = item.value;
              list.push(param);
            });
            this.maintenanceDictContents = list;
          }
        })
        .catch((response) => {});
    },
    getNowTime(time) {
      var now = time;
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      return defaultDate;
    },
    getInspectionContentList(){
    Contract.getInspectionContent().then((response) => {
        const data = response.data;
        if (data.code == 1) {
          console.log("数据：" + data);
        }
    })
      .catch((response) => {});
  },
  },

  
  created() {
    this.getContractStatusList();
    this.getMaintenanceList();
    this.getCustomerTypeList();
    this.getPersonChargeNameList();
    this.search({
      pageNo: 1,
      pageSize: 10,
    });
    this.menuList = this.$store.getters.getMenuPermission;
    this.getDictList();
    this.searchParam.signTime2 = this.getNowTime(new Date());
    this.searchParam.signTime = this.getNowTime(
      new Date(new Date().setFullYear(new Date().getFullYear() - 1))
    );
        this.getInspectionContentList();

  },
};
</script>
<style>
.searchBox-condition .date-class.el-date-editor.el-input {
  height: 30px;
}

.searchBox-condition .date-class .el-input__inner {
  border: 0;
  background-color: #f5f5f5;
  height: 30px;
  border-radius: 15px;
}

.searchBox-condition .date-class .el-range-input {
  background-color: #f5f5f5;
}

.searchBox-condition .date-class .el-input__icon {
  line-height: 3.5;
}

.searchBox-condition .select-class .el-input__icon {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/contract/list.vue